import { Box, Typography } from '@mui/material'
import { QueryDocument } from '@models'
import {
  ActionButton,
  SectionTag,
  SectionTagData,
  SectionWrapper,
  SimpleDocumentRenderer,
  CardData,
} from '@common-components'
import { Image } from '@media-components'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StyleClassNames, sectionTagCsx } from './styles'

export type PromptCardData = CardData & {
  document?: QueryDocument[]
  sectionTagData?: SectionTagData
}

type PromptCardDataProps = PromptCardData & {
  verticalAlign?: boolean
  csx?: CustomStyles<StyleClassNames>
}

export function PromptCard({
  title,
  document,
  description,
  imageData,
  actionButtonData,
  sectionTagData,
  csx,
}: PromptCardDataProps) {
  const styles = getStyles(defaultStyles, csx)

  return (
    <SectionWrapper {...styles('wrapper')} alternateBg>
      <Box {...styles('infoContainer')}>
        {sectionTagData && (
          <SectionTag {...sectionTagData} csx={sectionTagCsx} />
        )}
        {title && (
          <Typography variant="h3.500" color="neutral.white" component="h2">
            {title}
          </Typography>
        )}
        {!!document?.length && (
          <SimpleDocumentRenderer {...styles('document')} document={document} />
        )}
        {description && (
          <Typography variant="body1.400" color="grey.400">
            {description}
          </Typography>
        )}

        {actionButtonData && (
          <ActionButton
            {...actionButtonData}
            variant="outlined"
            darkTheme
            showArrow
          />
        )}
      </Box>
      {imageData && (
        <Box {...styles('image')}>
          <Image {...imageData} />
        </Box>
      )}
    </SectionWrapper>
  )
}
